import styled from 'styled-components'

export const AgreementContainer = styled.div`
  height: 20rem;
  overflow-y: auto;
  padding: 1rem;
  border: 1px solid var(--card-border);
  margin: 1.375rem 0 1.625rem 0;
  border-radius: 6px;
`
